export default __webpack_public_path__ + "static/media/interference-elimination.3cb2b6e6.png";